import SpriteIcon from '../../../core-components/assets/Icon';
import { formatDistanceToNow } from 'date-fns';
import { Greeny, SemanticError, SemanticInfo, Neutrals, Warning } from '../../../core-components/theme/color-palette/colors';

export const getCommIcon = (channel: string) => {
    switch (channel.toLowerCase()) {
      case 'email':
        return <SpriteIcon id="email_comm_icon" width={24} height={24} />;
      case 'whatsapp':
        return <SpriteIcon id="whatsapp_comm_icon" width={24} height={24} />;
      case 'sms':
        return <SpriteIcon id="sms_comm_icon" width={24} height={24} />;
      case 'call':
        return <SpriteIcon id="call_comm_icon" width={24} height={24} />;
      case 'report':
        return <SpriteIcon id="report_comm_icon" width={24} height={24} />;
      case 'general':
        return <SpriteIcon id="general_comm_icon" width={24} height={24} />;
      case 'CSMResponse':
        return <SpriteIcon id="responsecsm_comm_icon" width={24} height={24} />;
      case 'task':
        return <SpriteIcon id="task_comm_icon" width={24} height={24} />;
      case 'ticket':
        return <SpriteIcon id="ticket_comm_icon" width={24} height={24} />;
      default:
        return <SpriteIcon id="email_comm_icon" width={24} height={24} />;
    }
  };

export function formatCommunicationTimestamp(timestamp: string | number): string {
  let timeString = '';
  const date = typeof timestamp === 'string'
    ? new Date(timestamp)
    : new Date(Number(timestamp));
  if (!isNaN(date.getTime())) {
    const now = new Date();
    const diffMs = now.getTime() - date.getTime();
    const oneDayMs = 24 * 60 * 60 * 1000;
    if (diffMs > oneDayMs) {
      const day = date.getDate();
      const daySuffix = (d: number) => {
        if (d > 3 && d < 21) return 'th';
        switch (d % 10) {
          case 1: return 'st';
          case 2: return 'nd';
          case 3: return 'rd';
          default: return 'th';
        }
      };
      const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
      const year = date.getFullYear().toString().slice(-2);
      let hours = date.getHours();
      const minutes = date.getMinutes();
      const ampm = hours >= 12 ? 'PM' : 'AM';
      hours = hours % 12;
      hours = hours ? hours : 12;
      const minutesStr = minutes < 10 ? `0${minutes}` : `${minutes}`;
      timeString = `${day}${daySuffix(day)} ${monthNames[date.getMonth()]} ${year} | ${hours}:${minutesStr} ${ampm}`;
    } else {
      timeString = formatDistanceToNow(date, { addSuffix: true });
    }
  }
  return timeString;
}
  

export  const statusColorMap: Record<string, string> = {
  DELIVERED: Greeny[500],
  SENT: SemanticInfo[500],
  FAILED: SemanticError[500],
  UNDELIVERED: Warning[600],
  READ: SemanticInfo[100],
  NOT_AVAILABLE: Neutrals[200],
};

export const isImage = (filetype?: string, link?: string) => {
  if (!filetype && link) {
    return /\.(jpg|jpeg|png|gif|bmp|webp)$/i.test(link);
  }
  return filetype ? filetype.startsWith('image') : false;
};

export const isPDF = (filetype?: string, link?: string) => {
  if (!filetype && link) {
    return /\.pdf$/i.test(link);
  }
  return filetype ? filetype === 'application/pdf' : false;
};

